import React, { Component } from 'react';
import Formulario from './ProductoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Producto extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo, listarDepartamentos } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        listarDepartamentos();
    }
    
    render(){
        const { registroProducto, modificarProducto, loader, modulo, 
            listaDep, lectura, listarCuentasContables } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    registroProducto = {registroProducto}
                    crear = {crear}
                    modulo = {modulo}
                    listaDep = {listaDep}
                    lectura = {lectura}
                    modificarProducto = {modificarProducto}
                    listarCuentasContables = {listarCuentasContables}
                />
            </LoadMask>
        );
    }
}


export default Producto;